var map = {
	"./IMG_1_SEDE.png": 9090,
	"./IMG_2_SEDE.png": 6551,
	"./IMG_3_SEDE.png": 68,
	"./IMG_4_SEDE.png": 7233,
	"./IMG_5_SEDE.png": 1102,
	"./IMG_ABRE_SEDE.png": 923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7218;